import { releasesManager } from "./ReleasesManager.slice";

export const releasesManagerActions = { ...releasesManager.actions };
